
export default {
  data: () => ({

    rawData:  null,
    
    sundries: null,
    keys:     null,
    filters:  null,

    canvasForms:  null,

    
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  

  methods: {

  }


}